import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@src/store';
import { IAdvertise } from '@src/types/advertise';
import { TWeddingHallCard } from '@src/types/weddingHall';


interface AdvertiseState {
  slotAd: IAdvertise[];
  slotAdTitle: string;
  weddinghallAd: TWeddingHallCard[];
}


const initialState: AdvertiseState = {	
  slotAd:[],
  slotAdTitle: '',
  weddinghallAd:[]
};


const advertiseSlice = createSlice({
  name: 'advertise',
  initialState,
  reducers: {
    setSlodAdvertise(state, action: PayloadAction<{ ads: IAdvertise[]; title: string }>){
      state.slotAd = [...action.payload.ads];
      state.slotAdTitle = action.payload.title;
    },
    setWeddinghallAdvertise(state, action: PayloadAction<any>){
      const parsedData = action.payload.map((advertise) => ({
        ...advertise,
        maxIndividualHallPrice: 0, // 기본값 설정 (실제 값 필요하면 수정)
        minIndividualHallPrice: 0, // 기본값 설정 (실제 값 필요하면 수정)
      }));
      state.weddinghallAd = [...parsedData];      
    },
  },
});

export const { setSlodAdvertise,setWeddinghallAdvertise } = advertiseSlice.actions;
export const slotAdList = (state: RootState) => state.advertise.slotAd;
export const weddinghallAdList = (state: RootState) => state.advertise.weddinghallAd;
export default advertiseSlice.reducer;